import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass([{piedPageBlanc: _ctx.isLogin}, "pied-page"])
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToLegalNotice && _ctx.goToLegalNotice(...args))),
      class: "legal-notice"
    }, _toDisplayString(_ctx.$t('footer.legalNotice')), 1),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToConfidentialite && _ctx.goToConfidentialite(...args))),
      class: "legal-notice"
    }, _toDisplayString(_ctx.$t('footer.confidentialite')), 1)
  ], 2))
}